// Analytics tracking utility
interface AnalyticsEvent {
  category: string;
  action: string;
  label?: string;
}

class Analytics {
  private trackingId: string | undefined;

  constructor() {
    this.trackingId = import.meta.env.VITE_GA_TRACKING_ID;
  }

  trackSegmentClick(segmentType: string, segmentKey: string): void {
    this.track({
      category: 'Segment Interaction',
      action: 'click',
      label: `${segmentType}:${segmentKey}`,
    });
  }

  trackLearnMoreClick(segmentKey: string): void {
    this.track({
      category: 'External Link',
      action: 'click',
      label: segmentKey,
    });
  }

  trackLocaleChange(fromLocale: string, toLocale: string): void {
    this.track({
      category: 'Localization',
      action: 'change',
      label: `${fromLocale} → ${toLocale}`,
    });
  }

  trackPanelClose(method: 'button' | 'escape' | 'outside-click'): void {
    this.track({
      category: 'Panel',
      action: 'close',
      label: method,
    });
  }

  private track(event: AnalyticsEvent): void {
    // Send to analytics provider if configured
    if (this.trackingId && typeof window !== 'undefined') {
      // Google Analytics gtag
      if (typeof (window as any).gtag !== 'undefined') {
        (window as any).gtag('event', event.action, {
          event_category: event.category,
          event_label: event.label,
        });
      }
    }
  }
}

export const analytics = new Analytics();
